import React from 'react';
import Calculator from './TAA/Calculator';

export default function LandingPageThree() {
    return (
        <div>
            <section className='banner py-12 md:py-20 px-5 '>
                <div className='max-w-7xl mx-auto text-white text-center'>
                    <h1 className='text-5xl md:text-6xl font-bold md:mb-10'>The Easiest Way to STOP IRS Collections and Get Your Tax Debt Forgiven</h1>
                    <p className='text-2xl md:text-4xl my-3 md:my-6'>Start the process online for FREE</p>
                    <p className='text-2xl md:text-4xl font-bold mb-10'>in 3 simple steps</p>
                    <a href="#start" className=' text-2xl font-semibold bg-green-500 drop-shadow-md hover:bg-green-700 text-white rounded-full px-6 py-4'>Tap Here To Start</a>
                </div>

            </section>
            <section className='py-10 px-5'>
                <div className='max-w-7xl mx-auto'>
                    <p className='text-2xl md:text-3xl'><b>Step 1:</b> Begin the tax debt relief process for free by answering a few simple questions.</p>
                    <div className='flex-col justify-center text-center mt-10'>
                        <a href="#start" className=' text-2xl font-semibold bg-green-500 drop-shadow-md hover:bg-green-700 text-white rounded-full px-6 py-4'>Tap Here To Start</a>
                        <p className='text-base mt-5'>Takes 2 minutes</p>
                    </div>
                    <p className='text-2xl md:text-3xl my-5'><b>Step 2:</b> Have a free consultation with a tax relief expert who will get an IRS tax debt agent on the phone with you.</p>
                    <p className='text-2xl md:text-3xl my-5'><b>Step 3:</b> Learn the best ways to stop IRS collections activities and either get the tax debt forgiven or reduced with a great repayment plan.</p>
                    <p className='text-2xl md:text-3xl my-5'><b>Bonus Step:</b> If you like, for the best results with the least amount of time and frustration, you could even have a tax relief expert take care of your tax debt resolution for you with no out of pocket expense.</p>
                </div>
            </section>
            <section className='py-10 px-5 bg-gray-100'>
                <div className='max-w-7xl mx-auto' id="start">
                    {/* Form */}
                    <h2 className='px-5 py-3 text-center text-gray-900 font-bold md:leading-6 text-4xl mb-5'>Fill Out The Form Below To Get Started</h2>
                    <Calculator />

                    <h2 className='mt-20 px-5 py-3 text-center text-gray-900 font-bold md:leading-6 text-4xl mb-5'>What People Are Saying</h2>
                    <p className='text-xl italic my-5'>“After numerous attempts to resolve the matter on our own, we went to the Ovation Tax Group
                        and had a great meeting with Ms. Kim. She provided us with a clear path forward and took away all the anxiety from dealing with the issue ourselves.”
                        <br />  <b className='text-2xl not-italic'>– Will Dent</b> </p>
                    <p className='text-xl italic my-5'> “This team is phenomenal! I experienced an unexpected wage garnishment and contacted the team Ovation Tax Group. They are very knowledgeable, professional, and worked extremely fast as well. They resolved my tax issue within 48 hours!“</p>
                </div>
            </section>

        </div>
    );
}
